var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"app"}},[_c('Nav',[_c('Burger'),_c('Bio'),_c('Menu'),_c('Sidebar',{attrs:{"full-name":"Luchian Emil"}})],1),_c('CVShort'),_c('ShortContent'),_c('CVLong'),_c('LongContent')],1)}
var staticRenderFns = []

export { render, staticRenderFns }